module.exports = __webpack_public_path__ + "static/img/108.76ca26e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/108.png
// module id = Pqz4
// module chunks = 0